let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2cfNn")).then(() => parcelRequire('13EZY'));